export const getXDefaultLanguage = (alternateLanguages, actualLanguage) => {
  const allLanguages = alternateLanguages.concat([actualLanguage]);
  // Order is define as follow : en, fr, es, de, it, nl

  // en
  if (allLanguages.find(e => e.lang.includes('en'))) {
    return allLanguages.find(e => e.lang.includes('en'));
  }
  // fr
  if (allLanguages.find(e => e.lang.includes('fr'))) {
    return allLanguages.find(e => e.lang.includes('fr'));
  }
  // es
  if (allLanguages.find(e => e.lang.includes('es'))) {
    return allLanguages.find(e => e.lang.includes('es'));
  }
  // de
  if (allLanguages.find(e => e.lang.includes('de'))) {
    return allLanguages.find(e => e.lang.includes('de'));
  }
  // it
  if (allLanguages.find(e => e.lang.includes('it'))) {
    return allLanguages.find(e => e.lang.includes('it'));
  }
  // nl
  if (allLanguages.find(e => e.lang.includes('nl'))) {
    return allLanguages.find(e => e.lang.includes('nl'));
  }
};
